<template>
  <div>
    <v-card v-if="hideSection" class="mt-3">
      <v-card-title>
        <span>{{ sectionLabel }}</span>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-alert type="info" border="left" dense class="mb-3" v-if="sectionInfoBox">
          {{sectionInfoBox}}
        </v-alert>
        <el-form :model="form" ref="form" label-position="top">
          <v-row dense>
            <v-col cols="6" v-if="dataValidation(form, 'edu_institute_name')">
              <el-form-item label="Name of educational institution">
                <el-input v-model="form.edu_institute_name" @change="handleAutoSave(form)" style="width: 100%" />
              </el-form-item>
            </v-col>
            <v-col cols="12" v-if="dataValidation(form, 'edu_physical_address')">
              <el-form-item label="Physical address">
                <el-input v-model="form.edu_physical_address" @change="handleAutoSave(form)" style="width: 100%" />
              </el-form-item>
            </v-col>
            <v-col cols="12" v-if="dataValidation(form, 'edu_email_address')">
              <el-form-item label="Email address">
                <el-input v-model="form.edu_email_address" @change="handleAutoSave(form)" style="width: 100%" />
              </el-form-item>
            </v-col>
            <v-col cols="6" v-if="dataValidation(form, 'edu_website')">
              <el-form-item label="Website">
                <el-input v-model="form.edu_website" @change="handleAutoSave(form)" style="width: 100%" />
              </el-form-item>
            </v-col>
            <v-col cols="6" v-if="dataValidation(form, 'edu_contact_name')">
              <el-form-item label="Contact name">
                <el-input v-model="form.edu_contact_name" @change="handleAutoSave(form)" style="width: 100%" />
              </el-form-item>
            </v-col>
            <v-col cols="6" v-if="dataValidation(form, 'edu_contact_number')">
              <el-form-item label="Contact phone number">
                <el-input v-model="form.edu_contact_number" @change="handleAutoSave(form)" style="width: 100%" />
              </el-form-item>
            </v-col>
            <v-col cols="6" v-if="dataValidation(form, 'edu_contact_fax')">
              <el-form-item label="Contact fax">
                <el-input v-model="form.edu_contact_fax" @change="handleAutoSave(form)" style="width: 100%" />
              </el-form-item>
            </v-col>
          </v-row>
        </el-form>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn :loading="autoSave" :disabled="autoSave" color="primary" small @click.native="handleAutoSave(form)">
          {{ $t('global.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import autosave from '@/mixins/lmia_autosave'

export default {
  mixins: [autosave],
  props: {
    isDataValidation: {
      type: Boolean
    },
    sectionLabel: {
      type: String
    },
    sectionInfoBox: {
      type: String
    },
    memberUID: {
      type: String,
      required: true
    },
    memberID: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      edit: false,
      form: {
        application_id: this.$route.params.id,
        edu_institute_name: null,
        edu_physical_address: null,
        edu_email_address: null,
        edu_website: null,
        edu_contact_name: null,
        edu_contact_number: null,
        edu_contact_fax: null,
        sec_org_id: parseInt(localStorage.getItem('org_id'))
      },
      url: 'imms_table/lmia_yukon_app',
      getUrl: 'imms_table/lmia_yukon_app?application_imms_uuid=' + this.$route.params.id
    }
  },
  mounted() {
    this.fetch().then(data => {
      if (data.items != undefined && data.items.length > 0) {
        if (this.isDataValidation) {
          this.checkRow(data.items[0])
        }
        this.form = data.items[0]
      }
      else {
        if (this.isDataValidation) {
          this.checkRow(this.form)
        }
      }
    })
  }
}
</script>
